<template>
  <div
    :class="getLoading && 'bg-white'"
    class="flex-auto px-4 lg:px-6 py-6 pt-0"
  >
    <div
      v-if="getLoading"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <form v-if="!getLoading">
      <div class="flex justify-between items-center pr-4">
        <h6
          class="pl-4 text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"
        >
          Basic
        </h6>
        <button
          @click="handleAddSlides"
          type="button"
          class="bg-gray-500 text-white active:bg-gray-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
        >
          Add Slides
        </button>
      </div>
      <div class="flex flex-wrap">
        <div
          v-for="(value, name) in sliderAttrbutes"
          :key="name"
          class="w-full lg:w-4/12 px-4"
        >
          <div v-if="value.type === 'short_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description || ''"
              />
            </label>
            <input
              type="text"
              v-model="formDataLocal['slider'][`${name}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description || ''"
              />
            </label>
            <select
              v-model="formDataLocal['slider'][`${name}`]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description || ''"
              />
            </label>
            <URLInput
              :url="
                formDataLocal['slider'][`${name}`]
                  ? formDataLocal['slider'][`${name}`]
                  : ''
              "
              @update:url="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description || ''"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="
                formDataLocal['slider'][`${name}`]
                  ? formDataLocal['slider'][`${name}`]
                  : ''
              "
              @update:icon="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description || ''"
              />
            </label>
            <input
              v-model="formDataLocal['slider'][`${name}`]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
        <div
          class="w-full px-4"
          v-for="(value, index) in formDataLocal['slider']['slides']"
          :key="index"
        >
          <SlidePanel
            v-if="formDataLocal[index]"
            :index="String(index)"
            :formData="formData"
            :slideOptions="slideOptions"
            :handleDelete="handleDeleteSlides"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";
import SlidePanel from "@/components/ComponentModule/ImageSliderComponent/SlidePanel";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";

export default {
  name: "ImageSliderUpdatePageForm",
  components: { SlidePanel, URLInput, IconPicker, AttrTitleWithDescription },
  props: {
    formData: {
      type: Object,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.insertInstanceData();
  },
  watch: {
    instanceData() {
      this.insertInstanceData();
    },
    "formDataLocal.slider.slides"() {
      if (this.formDataLocal.slider.slides.length) {
        for (let i = 0; i < this.formDataLocal.slider.slides.length; i++) {
          if (!this.formDataLocal[i]) {
            this.formDataLocal[i] = { hotspots: [] };
          }
        }
      }
    }
  },
  computed: {
    instanceData() {
      if (this.getInstanceInfo && Object.keys(this.getInstanceInfo).length) {
        return this.getInstanceInfo.find((item) => {
          return item.id === this.instanceId;
        });
      } else {
        return {};
      }
    },
    slideOptions() {
      if (this.getSlideInstance && Object.keys(this.getSlideInstance).length) {
        return this.getSlideInstance.map((item) => {
          return { label: item.instance_name.split("|")[1], value: item.id };
        });
      } else {
        return [];
      }
    },
    sliderAttrbutes() {
      if (this.getAllAttributes) {
        let { slides, ...params } = this.getAllAttributes;// eslint-disable-line
        return params;
      }
      return {};
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    ...mapGetters([
      "getLoading",
      "getAllAttributes",
      "getSlideInstance",
      "getAllComponent",
      "getInstanceInfo"
    ])
  },
  methods: {
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    handleDeleteSlides(index) {
      this.formDataLocal["slider"]["slides"] = this.formDataLocal["slider"][
        "slides"
      ].filter((item, i) => {
        return i !== index;
      });
    },
    insertInstanceData() {
      if (this.instanceData && Object.keys(this.instanceData).length) {
        const instanceDataCopy = JSON.parse(JSON.stringify(this.instanceData));
        const slides = instanceDataCopy.attributes.slides.map((item) => {
          return { instance: item };
        });
        instanceDataCopy.attributes.slides = slides;
        this.formDataLocal.slider = instanceDataCopy.attributes;
      }
    },
    handleAddSlides() {
      this.formDataLocal["slider"]["slides"].push({
        instance: ""
      });
      this.formDataLocal[this.formDataLocal["slider"]["slides"].length - 1] = {
        hotspots: []
      };
    },
    handleUpdateValue(val, name) {
      this.formDataLocal["slider"][name] = val;
    }
  }
};
</script>
